import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './HelpModal.scss';
/**
 * @component HelpModal
 * @since 1.0.0
 */
export function HelpModal(props) {
    const className = classNames('dynamic-sales-form-help-modal', props.className);
    return (React.createElement("div", { className: className },
        React.createElement("strong", null, t('Get Your Centralio Quote')),
        React.createElement("p", { className: "presentation-section-description--text" }, t('This dynamic sales form allows you to automatically generate a personalized quote. Once the form is completed, you will have immediate access to your preliminary quote, and a secure link will be sent to you by email.')),
        React.createElement("br", null),
        React.createElement("strong", null, t('1. Make Your Selection')),
        React.createElement("p", { className: "presentation-section-description--text" }, t('Choose the products or services that meet your needs.')),
        React.createElement("strong", null, t('2. Enter Your Contact Information')),
        React.createElement("p", { className: "presentation-section-description--text" }, t('Your details allow us to generate a tailored quote, send you a secure link by email, and notify our team for a follow-up if necessary.')),
        React.createElement("strong", null, t('3. Add Additional Information')),
        React.createElement("p", { className: "presentation-section-description--text" }, t("If you'd like to further refine the offer based on your specific situation, you can provide additional details.")),
        React.createElement("strong", null, t('4. Get Your Quote')),
        React.createElement("p", { className: "presentation-section-description--text" }, t('By accepting the use of your data, click the button to receive your personalized quote in real time.')),
        React.createElement("br", null)));
}
